<template>
  <div>
    <v-calendar
      is-inline
      is-double-paned
      is-linked
      is-expanded
      mode="multiple"
      :show-day-popover="false"
      :attributes="attrs"
      :formats="formats"
      @dayclick="dayClicked"
    />
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },

    entries: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedDate: new Date(),
      attrs: [],
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
      },
    };
  },

  watch: {
    entries: {
      handler() {
        this.setDates();
      },
      deep: true,
    },
  },

  mounted() {
    this.setDates();

    // console.log(entries);
  },

  methods: {
    dayClicked(day) {
      this.selectedDate = day.date;
      Bus.$emit('day_clicked', day);
      this.setDates();
    },

    setDates() {
      this.attrs = [];

      let start = null;
      let end = null;

      Object.keys(this.entries).forEach((key) => {
        const k = parseInt(key, 10);

        // Check to see if this is a range of dates
        if (this.entries[k + 1]) {
          const a = new Date(this.entries[k].date);
          const b = new Date(this.entries[k + 1].date);
          if (start === null && this.dateDiffInDays(a, b) === 1) {
            // This is the start of the range
            start = this.entries[k].date;
          } else if (start !== null) {
            if (this.dateDiffInDays(a, b) !== 1) {
              // The next entry is not immediately following so this entry marks the end of the range
              end = this.entries[k].date;
            } else if (this.dateDiffInDays(a, b) === 1 && !this.entries[k + 2]) {
              // If there aren't anymore dates, then this is also the end
              end = this.entries[k + 1].date;
            }
          }
        }

        if (start === null && end === null) {
          // This is not a range
          // console.log('not a range');
          this.attrs.push(this.formatEntryToCalendarAttribute(this.entries[k], 'highlight'));
        } else if (start !== null && end !== null) {
          // This is a range
          // console.log('is a range');
          const range = {
            start,
            end,
          };
          this.attrs.push(this.formatEntryToCalendarAttribute(this.entries[k], 'highlight', range));

          start = null;
          end = null;
        }

        // this.attrs.push(this.formatEntryToCalendarAttribute(this.entries[k], 'styles'));
      });

      if (this.selectedDate !== null) {
        this.attrs.push(
          this.formatEntryToCalendarAttribute(
            {
              date: this.selectedDate,
            },
            'highlight',
          ),
        );
      }
    },

    dateDiffInDays(a, b) {
      const MS_PER_DAY = 1000 * 60 * 60 * 24;

      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / MS_PER_DAY);
    },

    formatEntryToCalendarAttribute(entry, mode, dates) {
      if (mode === 'highlight') {
        // console.log(dates || entry.date);
        if (entry.model) {
          return {
            key: `hl-entry.${entry.id}`,
            highlight: {
              backgroundColor: 'lightgreen', // color of circle
              width: '1.5rem',
              height: '1.5rem',
            },
            // Just use a normal style
            contentStyle: {
              color: '#fff', // color of text
            },
            dates: dates || entry.date,
            customData: entry,
          };
        }
        return {
          key: `hl-entry.${entry.id}`,
          highlight: {
            backgroundColor: 'transparent',
            borderWidth: '1px',
            borderColor: 'red',
            width: '1.7rem',
            height: '1.7rem',
            borderRadius: '0rem',
          },
          // Just use a normal style
          contentStyle: {
            color: '#000', // color of text
          },
          dates: dates || entry.date,
          customData: entry,
        };
      }

      return {
        key: `entry.${entry.id}`,
        dot: {
          backgroundColor: 'red',
        },
        bar: {
          backgroundColor: 'blue',
          opacity: 0.3,
        },
        dates: entry.date,

        customData: entry,
      };
    },
  },
};
</script>
